import { handleActions } from 'redux-actions';
import { SET_RSS_FEED_ORDER_BY } from './actions';

const initialState = {
  rssFeedOrderBy: {
    orderDir: 'desc',
    keyName: 'updatedAt',
  },
};

export const setRssFeedOrderBy = (state, { payload }) => {
  const { rssFeedOrderBy } = payload;

  return {
    ...state,
    rssFeedOrderBy,
  };
};

const mappedReducers = {
  [SET_RSS_FEED_ORDER_BY]: setRssFeedOrderBy,
};

const rssFeedTableState = handleActions(mappedReducers, initialState);

export default rssFeedTableState
